import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import AdminsPage from "./modules/ContentManager/admins/AdminsPage";
import EditAdminsPage from "./modules/ContentManager/admins/EditAdminsPage";
import SessionsPage from "./modules/ContentManager/sessions/SessionsPage";
import EditSessionPage from "./modules/ContentManager/sessions/EditSessionPage";
import SessionDetailPage from "./modules/ContentManager/sessions/SessionDetailPage";
import { DashboardPage } from "./pages/DashboardPage";
import { useIsAdmin } from "./hooks/useIsAdmin";

export default function BasePage() {
	const isAdmin = useIsAdmin();
	return (
		<Switch>
			{/* Redirect from root URL to /dashboard. */}
			<Redirect exact from="/" to="/dashboard" />
			{/* Rutas de escritura: el rol de solo lectura (cliente) vuelve al dashboard */}
			{!isAdmin && <Redirect from="/edit-session" to="/dashboard" />}
			{!isAdmin && <Redirect from="/admins" to="/dashboard" />}
			{!isAdmin && <Redirect from="/edit-admin" to="/dashboard" />}
			<ContentRoute path="/dashboard" component={DashboardPage} />
			{/* Sesiones */}
			<ContentRoute from="/sessions" component={SessionsPage} />
			<ContentRoute from="/edit-session/:id?" component={EditSessionPage} />
			<ContentRoute from="/session/:id" component={SessionDetailPage} />
			{/* Administradores */}
			<ContentRoute from="/admins" component={AdminsPage} />
			<ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />
			<Redirect to="/error" />
		</Switch>
	);
}
